/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { AppCSS, Spacer, TxtInput, ChkInputBox } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Container } from "../../../../globalstyled";
import { toast } from "react-toastify";
import { logEvent, ITEM_CREATION_EVENTS } from "../../../../utils/amplitude";

import { Box, Typography } from "@mui/material";

import UpArrowIcon from "../../../../images/UploadIcon.png";
import DownArrowIcon from "../../../../images/DownloadIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import LaborMeasurementsDrawer from "../SideDrawer/index";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";

import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import { LABOR_MEASUREMENTS_TABLE_HEADER_LIST } from "../../../../contants/dashboardHeader";

import {
  LaborMeasurements,
  ProductSystem,
  ProductSystemForMiscField,
} from "../../../../redux/types/creation";
import "react-toastify/dist/ReactToastify.css";
import { FormTitleTypography, ArrowIcon } from "../itemCreation.styled";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import Pagination from "../ItemCreationComponent/Pagination";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import { LABOR_MEASUREMENT_DRAWER_DETAILS } from "../../../../contants/itemsCreation";
import {
  useArchiveLaborMeasurement,
  useCreateLaborMeasurement,
  useUpdateLaborMeasurement,
  useUpdateLaborMeasurementOrder,
} from "../../../../apolloClient/hooks/itemCreation/createHooks";
import { extractCheckedIds } from "../../../../utils/formatting";
import { CreateLaborMeasurementInput } from "../../../../types/graphQlQuery.interface";
import EmptyTable from "../../../../components/table/EmptyTable";
import ProductSystemParentIdsTable from "../ItemCreationComponent/ProductSystemParentIdsTable";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

interface MaterialMeasurementsTableProps {
  laborMeasurementsData: LaborMeasurements[];
  refetchLaborMeasurement?: Function;
  productsIds?: ProductSystem[];
  permissions?: boolean;
}

export const LaborMeasurementsTable: React.FC<
  MaterialMeasurementsTableProps
> = ({
  laborMeasurementsData,
  refetchLaborMeasurement,
  productsIds,
  permissions,
}) => {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(8);
  const [keyword, setKeyword] = React.useState("");
  const [isEditOrderMode, setIsEditOrderMode] = useState(false);

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openRowDetailsDrawer, setOpenRowDetailsDrawer] =
    React.useState<boolean>(false);

  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<LaborMeasurements | null>(null);

  const [openAlert, setOpenAlert] = useState(false);

  const [productSystemId, setProductSystemId] = useState<string>("");
  const [productSystemIdsTableData, setProductSystemIdsTableData] = useState<
    { parentId: number }[]
  >([]);
  const [materialMeasurementName, setMaterialMeasurementName] =
    useState<string>("");
  const [measurementUnit, setMeasurementUnit] = useState<string>("");

  const [showProductSystemParent, setShowProductSystemParent] =
    useState<boolean>(false);

  const [checkboxStates, setCheckboxStates] = useState<{
    [key: number]: boolean;
  }>({});

  const [selectedMeasurement, setSelectedMeasurement] =
    React.useState<LaborMeasurements | null>(null);

  const { createLaborMeasurement } = useCreateLaborMeasurement();
  const { updateLaborMeasurement } = useUpdateLaborMeasurement();
  const { archiveLaborMeasurement } = useArchiveLaborMeasurement();

  const [openArchieveDialog, setOpenArchieveDialog] = useState(false);
  const [selectedLaborMeasurement, setSelectedLaborMeasurement] =
    useState<LaborMeasurements | null>(null);

  const { updateLaborMeasurementOrder } = useUpdateLaborMeasurementOrder();

  const handleArchive = (row: LaborMeasurements) => {
    setSelectedLaborMeasurement(row);
    setOpenArchieveDialog(true);
  };

  const confirmArchieve = async () => {
    if (selectedLaborMeasurement) {
      const success = await archiveLaborMeasurement(
        selectedLaborMeasurement.id
      );
      if (success) {
        toast(`${selectedLaborMeasurement.name} Archived!`, { type: "error" });
        logEvent(ITEM_CREATION_EVENTS.LABOR_MEASUREMENT_ARCHIVED, { measurement_id: selectedLaborMeasurement.id, measurement_name: selectedLaborMeasurement.name, timestamp: new Date().toISOString() });
        refetchLaborMeasurement();
      } else {
        toast(`Failed to Archive ${selectedLaborMeasurement.name}`);
      }
      setOpenArchieveDialog(false);
      setSelectedLaborMeasurement(null);
    }
  };

  const cancelArchieve = () => {
    setOpenArchieveDialog(false);
    setSelectedLaborMeasurement(null);
  };

  const viewRowDetails = (rowData: LaborMeasurements) => {
    setViewRowDetailsData(rowData);
    handleViewRowDetailsDrawerOpen();
  };

  const handleViewRowDetailsDrawerOpen = () => {
    setOpenRowDetailsDrawer(true);
  };

  const handleViewRowDetailsDrawerClose = () => {
    setOpenRowDetailsDrawer(false);
  };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const [laborMeasurements, setLaborMeasurements] = useState<
    LaborMeasurements[]
  >(laborMeasurementsData);

  const filterLaborMeasurements = () => {
    const dataToFilter = laborMeasurements || laborMeasurementsData;
    if (keyword.length > 0 && Array.isArray(dataToFilter)) {
      return dataToFilter.filter((item) => {
        const laborMeasurementsName = `${item.name}`;
        const laborMeasurementsUnit = `${item.unit}`;
        return (
          laborMeasurementsName.toLowerCase().includes(keyword.toLowerCase()) ||
          laborMeasurementsUnit.toLowerCase().includes(keyword.toLowerCase())
        );
      });
    }
    return dataToFilter;
  };

  const handleDragEnd = async (result: any) => {
    if (!permissions) return; // Prevent drag-and-drop functionality if permissions are false
    if (!result.destination) return;

    // Get the filtered list
    const filteredItems = filterLaborMeasurements();

    let sourceIndexInFullList: number;
    let destinationIndexInFullList: number;

    if (isEditOrderMode) {
      // In edit order mode, we're working with the full filtered list
      sourceIndexInFullList = laborMeasurements.findIndex(
        (item) => item.id === filteredItems[result.source.index].id
      );
      destinationIndexInFullList = laborMeasurements.findIndex(
        (item) => item.id === filteredItems[result.destination.index].id
      );
    } else {
      // In normal mode, calculate the start index of the current page in the full list
      const startIndex = page * rowsPerPage;
      
      // Map the indices from the paginated slice to the full list
      sourceIndexInFullList = laborMeasurements.findIndex(
        (item) => item.id === filteredItems[startIndex + result.source.index].id
      );
      destinationIndexInFullList = laborMeasurements.findIndex(
        (item) => item.id === filteredItems[startIndex + result.destination.index].id
      );
    }

    // Reorder the full list
    const reorderedItems = Array.from(laborMeasurements);
    const [removed] = reorderedItems.splice(sourceIndexInFullList, 1);
    reorderedItems.splice(destinationIndexInFullList, 0, removed);

    setLaborMeasurements(reorderedItems); // Update local state for immediate feedback

    const newOrder = reorderedItems.map((item) => item.id);

    try {
      const success = await updateLaborMeasurementOrder(newOrder);
      if (success) {
        toast("Labor measurement order updated.", {
          type: "success",
          position: "top-center",
        });
        logEvent(ITEM_CREATION_EVENTS.LABOR_MEASUREMENT_ORDER_UPDATED, { timestamp: new Date().toISOString() });
        refetchLaborMeasurement();
      } else {
        toast("Failed to update labor measurement order.", {
          type: "error",
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error updating labor measurement order:", error);
      toast("An error occurred while updating the order.", {
        type: "error",
        position: "top-center",
      });
    }
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterLaborMeasurements().length / rowsPerPage) - 1
      )
    );
  };

  const handleEditOrderMode = () => {
    setIsEditOrderMode(true);
    setPage(0); 
  };

  const handleExitEditOrderMode = () => {
    setIsEditOrderMode(false);
    setPage(0);
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleEditClick = (measurement: LaborMeasurements) => {
    setSelectedMeasurement(measurement);
    setMaterialMeasurementName(measurement.name);
    setMeasurementUnit(measurement.unit);
    setCheckboxStates(
      (measurement.parents || []).reduce((acc, parent) => {
        if (parent.id) {
          acc[parent.id] = true;
        }
        return acc;
      }, {} as { [key: number]: boolean })
    );
    setOpenDrawer(true);
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !materialMeasurementName,
        message: "Please Enter the labor measurement name",
      },
      {
        condition: !measurementUnit,
        message: "Please Enter the labor measurement unit",
      },
      {
        condition: !extractCheckedIds(checkboxStates).length,
        message: "Please select a minimum of one product system!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    if (selectedMeasurement) {
      // Edit mode
      const input = {
        id: selectedMeasurement.id,
        name: materialMeasurementName,
        unit: measurementUnit,
        parentIds: extractCheckedIds(checkboxStates),
      };

      const success = await updateLaborMeasurement(input);
      if (success) {
        toast("Labor measurement updated successfully.", {
          type: "success",
          className: "toast-message",
          position: "top-center",
        });
        logEvent(ITEM_CREATION_EVENTS.LABOR_MEASUREMENT_UPDATED, { measurement_id: selectedMeasurement.id, measurement_name: materialMeasurementName, timestamp: new Date().toISOString() });
        refetchLaborMeasurement();
        handleDrawerClose();
        setMaterialMeasurementName("");
        setMeasurementUnit("");
        setCheckboxStates({});
        setSelectedMeasurement(null);
        return;
      } else {
        console.error("Failed to update labor measurement.");
      }
    } else {
      // Create mode
      const checkedParentIds = extractCheckedIds(checkboxStates);

      const input: CreateLaborMeasurementInput = {
        name: materialMeasurementName,
        unit: measurementUnit,
        parentIds: checkedParentIds,
      };

      const success = await createLaborMeasurement(input);
      if (success) {
        toast("Labor measurement created successfully.", {
          type: "success",
          className: "toast-message",
          position: "top-center",
        });
        logEvent(ITEM_CREATION_EVENTS.LABOR_MEASUREMENT_CREATED, { measurement_name: materialMeasurementName, timestamp: new Date().toISOString() });
        refetchLaborMeasurement();
        handleDrawerClose();
        setMaterialMeasurementName("");
        setMeasurementUnit("");
        setCheckboxStates({});
        return;
      } else {
        console.error("Failed to create labor measurement.");
      }
    }
  };

  const createLaborMeasurementsForm = () => {
    return (
      <LaborMeasurementsDrawer open={openDrawer} onClose={handleDrawerClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle={
              selectedMeasurement
                ? "Edit labor measurement"
                : "Create new labor measurement"
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <ColDiv
                style={{
                  gap: "5px",
                }}
              >
                <Spacer size={1} direction="col" />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Name</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter name"
                  onChange={setMaterialMeasurementName}
                  required={true}
                  value={materialMeasurementName}
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  <FormTitleTypography>Measurement unit</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter unit"
                  onChange={setMeasurementUnit}
                  required={true}
                  value={measurementUnit}
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <Spacer size={1} direction="col" />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Lbl
                    title="Associated product systems"
                    size={16}
                    width={80}
                    bold={600}
                  />
                </Box>
                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "inherit",
                    borderRadius: "10px",
                    border: "1px solid rgba(173, 173, 173, 1)",
                    height: "fit-content",
                    minHeight: "50px",
                    paddingY: "10px",
                  }}
                  onClick={() =>
                    setShowProductSystemParent(!showProductSystemParent)
                  }
                >
                  <RowDiv
                    style={{
                      width: "100%",
                      paddingLeft: "20px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Lbl
                        title="
                        Select associated product systems"
                        size={16}
                        mobileFontSize={16}
                        isFullWidth={true}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "40%",
                        alignItems: "center",
                        justifyContent: "end",
                        paddingRight: "20px",
                      }}
                    >
                      {showProductSystemParent ? (
                        <ArrowIcon src={UpArrowIcon} />
                      ) : (
                        <ArrowIcon src={DownArrowIcon} />
                      )}
                    </Box>
                  </RowDiv>

                  {showProductSystemParent && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        justifyContent: "center",
                        alignItems: "start",
                        width: "100%",
                        paddingX: "20px",
                      }}
                    >
                      {productsIds.map((item) => (
                        <Box
                          key={`checkProductsSystemParent ${item.id}`}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            cursor: "pointer",
                            justifyContent: "start",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <ChkInputBox
                            onChange={(value: boolean) => {
                              setCheckboxStates((prevCheckboxStates) => ({
                                ...prevCheckboxStates,
                                [item.id]: value,
                              }));
                              setShowProductSystemParent(true);
                            }}
                            placeholder=""
                            width={50}
                            marginTop={0}
                            marginBottom={0}
                            height={20}
                            background="inherit"
                            checked={checkboxStates[item.id] || false}
                          />
                          <Typography>{item.name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={() => {
            handleDrawerClose();
            setSelectedMeasurement(null);
          }}
          onCreate={onTapSubmitForm}
          submitText={selectedMeasurement ? "Update" : "Create"}
        />
      </LaborMeasurementsDrawer>
    );
  };

  const showLaborMeasurementRowDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openRowDetailsDrawer}
        handleDrawerClose={handleViewRowDetailsDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Labor Measurements Details"
        rowArrayTableComponent={(
          value: ProductSystemForMiscField[],
          key?: string
        ) => <ProductSystemParentIdsTable value={value} key={key} />}
        detailsOfRowToBeDisplay={LABOR_MEASUREMENT_DRAWER_DETAILS}
      />
    );
  };
  const LaborMeasurementsTable = () => {
    const paginatedData = filterLaborMeasurements().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterLaborMeasurements().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search labor measurements"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
            {/* Edit Order Mode Toggle */}
            {permissions && (
              <>
                {!isEditOrderMode ? (
                  <Box
                    component="button"
                    onClick={handleEditOrderMode}
                    sx={{
                      padding: "10px 20px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#0056b3",
                      },
                    }}
                  >
                    Edit Order
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#ff6b35",
                        display: { xs: "none", md: "block" },
                      }}
                    >
                      Edit Order Mode - Drag items to reorder
                    </Typography>
                    <Box
                      component="button"
                      onClick={handleExitEditOrderMode}
                      sx={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: 500,
                        cursor: "pointer",
                        transition: "all 0.2s",
                        backgroundColor: "#28a745",
                        color: "white",
                        border: "none",
                        whiteSpace: "nowrap",
                        "&:hover": {
                          backgroundColor: "#1e7e34",
                        },
                      }}
                    >
                      Done
                    </Box>
                  </Box>
                )}
              </>
            )}

            {permissions && !isEditOrderMode && (
              <Box
                component="button"
                onClick={() => {
                  handleDrawerOpen();
                  setMaterialMeasurementName("");
                  setMeasurementUnit("");
                  setCheckboxStates({});
                  setSelectedMeasurement(null);
                }}
                sx={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                  transition: "all 0.2s",
                  backgroundColor: "#4b87ed",
                  color: "white",
                  border: "none",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    backgroundColor: "#3a6fd8",
                  },
                }}
              >
                + Create new measurement
              </Box>
            )}
          </Box>
        </Box>

        {/* Edit Order Mode indicator for mobile */}
        {isEditOrderMode && (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#ff6b35",
              display: { xs: "block", md: "none" },
              mb: 2,
              textAlign: "center",
            }}
          >
            Edit Order Mode - Drag items to reorder
          </Typography>
        )}

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "10%", minWidth: "50px" }}>ID</Box>
            <Box sx={{ width: "35%", minWidth: "100px" }}>Name</Box>
            <Box sx={{ width: "25%", minWidth: "80px" }}>Unit</Box>
            <Box sx={{ width: "30%", minWidth: "150px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body with Drag and Drop */}
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="laborMeasurements" isDropDisabled={!permissions}>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{ width: "100%" }}
                >
                  {filterLaborMeasurements().length === 0 ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "48px 24px",
                        textAlign: "center",
                      }}
                    >
                      <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                        No labor measurement available
                      </Typography>
                    </Box>
                  ) : (
                    (() => {
                      const filteredData = filterLaborMeasurements();
                      const itemsToShow = isEditOrderMode 
                        ? filteredData
                        : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
                      
                      return itemsToShow.map((row, index) => (
                        <Draggable
                          key={row.id}
                          draggableId={row.id.toString()}
                          index={index}
                          isDragDisabled={!permissions}
                        >
                          {(provided, snapshot) => (
                            <Box
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                alignItems: { xs: "flex-start", md: "center" },
                                padding: { xs: "14px 16px", md: "14px 20px" },
                                borderBottom: "1px solid #f0f0f0",
                                gap: { xs: 1, md: 0 },
                                width: "100%",
                                backgroundColor: snapshot.isDragging ? "#e3f2fd" : "white",
                                "&:hover": {
                                  backgroundColor: snapshot.isDragging ? "#e3f2fd" : "#f8f9fa",
                                },
                                "&:last-child": {
                                  borderBottom: "none",
                                },
                                cursor: permissions ? "grab" : "default",
                              }}
                            >
                              {/* ID */}
                              <Box sx={{ width: { xs: "100%", md: "10%" }, minWidth: { md: "50px" }, paddingRight: { md: "16px" } }}>
                                <Typography
                                  sx={{
                                    display: { xs: "block", md: "none" },
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: "#9ca3af",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                    marginBottom: "2px",
                                  }}
                                >
                                  ID
                                </Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                                  {row.id}
                                </Typography>
                              </Box>

                              {/* Name */}
                              <Box sx={{ width: { xs: "100%", md: "35%" }, minWidth: { md: "100px" }, maxWidth: { md: "35%" }, paddingRight: { md: "16px" } }}>
                                <Typography
                                  sx={{
                                    display: { xs: "block", md: "none" },
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: "#9ca3af",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                    marginBottom: "2px",
                                  }}
                                >
                                  Name
                                </Typography>
                                <Typography sx={{ 
                                  fontSize: 14, 
                                  color: "#374151",
                                  wordBreak: "break-word",
                                  lineHeight: 1.4
                                }}>
                                  {row.name}
                                </Typography>
                              </Box>

                              {/* Unit */}
                              <Box sx={{ width: { xs: "100%", md: "25%" }, minWidth: { md: "80px" }, maxWidth: { md: "25%" }, paddingRight: { md: "16px" } }}>
                                <Typography
                                  sx={{
                                    display: { xs: "block", md: "none" },
                                    fontSize: 11,
                                    fontWeight: 500,
                                    color: "#9ca3af",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                    marginBottom: "2px",
                                  }}
                                >
                                  Unit
                                </Typography>
                                <Typography sx={{ 
                                  fontSize: 14, 
                                  color: "#374151",
                                  wordBreak: "break-word",
                                  lineHeight: 1.4
                                }}>
                                  {row.unit}
                                </Typography>
                              </Box>

                              {/* Actions */}
                              <Box
                                sx={{
                                  width: { xs: "100%", md: "30%" },
                                  minWidth: { md: "150px" },
                                  display: "flex",
                                  justifyContent: { xs: "flex-start", md: "flex-end" },
                                  gap: 1,
                                  flexWrap: "wrap",
                                  marginTop: { xs: 1, md: 0 },
                                }}
                              >
                                <Box
                                  component="button"
                                  onClick={() => viewRowDetails(row)}
                                  sx={{
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                    backgroundColor: "#e5e7eb",
                                    color: "#374151",
                                    border: "none",
                                    "&:hover": {
                                      backgroundColor: "#d1d5db",
                                    },
                                  }}
                                >
                                  View
                                </Box>
                                {permissions && !isEditOrderMode && (
                                  <>
                                    <Box
                                      component="button"
                                      onClick={() => handleEditClick(row)}
                                      sx={{
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        transition: "all 0.2s",
                                        backgroundColor: "#e5e7eb",
                                        color: "#374151",
                                        border: "none",
                                        "&:hover": {
                                          backgroundColor: "#d1d5db",
                                        },
                                      }}
                                    >
                                      Edit
                                    </Box>
                                    <Box
                                      component="button"
                                      onClick={() => handleArchive(row)}
                                      sx={{
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        cursor: "pointer",
                                        transition: "all 0.2s",
                                        backgroundColor: "#fee2e2",
                                        color: "#dc2626",
                                        border: "none",
                                        "&:hover": {
                                          backgroundColor: "#fecaca",
                                        },
                                      }}
                                    >
                                      Archive
                                    </Box>
                                  </>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Draggable>
                      ));
                    })()
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          {/* Pagination */}
          {!isEditOrderMode && filterLaborMeasurements().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };


  const laborMeasurementsContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(laborMeasurementsData) && LaborMeasurementsTable()}
        {createLaborMeasurementsForm()}
        {showLaborMeasurementRowDetails()}
      </Box>
    );
  };

  return (
    <>
      {laborMeasurementsContainer()}
      <ConfirmationDialog
        open={openArchieveDialog}
        title="Confirm Archive"
        message={`Are you sure you want to Archive "${selectedLaborMeasurement?.name}"?`}
        onConfirm={confirmArchieve}
        onCancel={cancelArchieve}
      />
    </>
  );
};
